// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Serialized from "../Data.Serialized/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Common_Translations_Keys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic_Form from "../Restaumatic.Form/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic_Prelude_Specular from "../Restaumatic.Prelude.Specular/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_Extra_Attr from "../Specular.Extra.Attr/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Specular_Select from "../Specular.Select/index.js";
import * as Unscramble from "../Unscramble/index.js";
var asDateMaybeDay = {
    fromMaybeDate: /* #__PURE__ */ (function () {
        var $40 = Data_Functor.map(Data_Maybe.functorMaybe)(Data_Newtype.wrap());
        return function ($41) {
            return Data_Maybe.Just.create($40($41));
        };
    })(),
    toMaybeDate: /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe)(/* #__PURE__ */ Data_Newtype.unwrap())
};
var asDateMaybeDate = /* #__PURE__ */ (function () {
    return {
        fromMaybeDate: Data_Maybe.Just.create,
        toMaybeDate: Control_Category.identity(Control_Category.categoryFn)
    };
})();
var asDateDay = {
    fromMaybeDate: /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe)(/* #__PURE__ */ Data_Newtype.wrap()),
    toMaybeDate: /* #__PURE__ */ (function () {
        var $42 = Data_Newtype.unwrap();
        return function ($43) {
            return Data_Maybe.Just.create($42($43));
        };
    })()
};
var asDateDate = /* #__PURE__ */ (function () {
    return {
        fromMaybeDate: Control_Category.identity(Control_Category.categoryFn),
        toMaybeDate: Data_Maybe.Just.create
    };
})();
var toMaybeDate = function (dict) {
    return dict.toMaybeDate;
};
var setElementProperty = function (name) {
    return function (value) {
        return function (node, v) {
            return $foreign["_setElementProperty"](node, name, value);
        };
    };
};
var select = function (dictShow) {
    return function (dictEq) {
        return function (dictToOptionId) {
            return function (dictIsSelectField) {
                return function (props) {
                    return function (f) {
                        return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_FRP_Host.liftHost(Specular_Dom_Builder.monadCleanupBuilder)(Specular_Dom_Builder.monadEffectBuilder)(Restaumatic_Form.selectInput(dictShow)(dictEq)(dictIsSelectField)(f)))(function (i) {
                            return Specular_Select.select(Data_Maybe.eqMaybe(dictEq))(Data_Maybe.showMaybe(dictShow))(Specular_Select.toOptionIdMaybe(dictToOptionId))([ Specular_Dom_Element.on("blur")(function (v) {
                                return i.onTouch;
                            }), Data_Foldable.fold(Data_Foldable.foldableArray)(Specular_Dom_Element.monoidProp)(props) ])(i.displayedOptions)(new Specular_Ref.Ref(i.displayedValue, Specular_Callback.mkCallback(function (cb) {
                                return function __do() {
                                    var old = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(i.displayedValue)();
                                    return Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(cb(old))(function (value) {
                                        return i.onChange(value);
                                    })();
                                };
                            })));
                        });
                    };
                };
            };
        };
    };
};
var radio = function (dictShow) {
    return function (dictEq) {
        return function (dictIsSelectField) {
            return function (groupName) {
                return function (option) {
                    return function (props) {
                        return function (f) {
                            return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_FRP_Host.liftHost(Specular_Dom_Builder.monadCleanupBuilder)(Specular_Dom_Builder.monadEffectBuilder)(Restaumatic_Form.selectInput(dictShow)(dictEq)(dictIsSelectField)(f)))(function (i) {
                                var boolDisplay = Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(i.displayedValue)(function (v) {
                                    if (v instanceof Data_Maybe.Just && v.value0 instanceof Data_Maybe.Just) {
                                        return Data_Eq.eq(dictEq)(v.value0.value0)(option.key);
                                    };
                                    return false;
                                });
                                return Specular_Dom_Element.el("input")(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Specular_Dom_Element.bindChecked(new Specular_Ref.Ref(boolDisplay, Specular_Callback.mkCallback(function (cb) {
                                    return function __do() {
                                        var old = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(boolDisplay)();
                                        var $34 = cb(old);
                                        if ($34) {
                                            return i.onChange(new Data_Maybe.Just(option.key))();
                                        };
                                        return Data_Unit.unit;
                                    };
                                }))), Specular_Dom_Element.attr("type")("radio"), Specular_Dom_Element.attr("name")(groupName), Specular_Dom_Element.on("blur")(Specular_Callback.mkCallback(function (v) {
                                    return i.onTouch;
                                })) ])(props))(Restaumatic_Prelude_Specular.wempty);
                            });
                        };
                    };
                };
            };
        };
    };
};
var genericTextInput = function (dictIsTextField) {
    return function (tag) {
        return function (bindValue) {
            return function (props) {
                return function (field) {
                    var i = Restaumatic_Form.textInput(dictIsTextField)(field);
                    return Specular_Dom_Element.el(tag)(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ bindValue(new Specular_Ref.Ref(i.displayedValue, Specular_Callback.mkCallback(function (f) {
                        return function __do() {
                            var old = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(i.displayedValue)();
                            return i.onChange(f(old))();
                        };
                    }))), Specular_Dom_Element.on("blur")(Specular_Callback.mkCallback(function (v) {
                        return i.onTouch;
                    })), Specular_Dom_Element.attrD("placeholder")(i.placeholder) ])(props))(Restaumatic_Prelude_Specular.wempty);
                };
            };
        };
    };
};
var textArea = function (dictIsTextField) {
    return genericTextInput(dictIsTextField)("textarea")(Specular_Dom_Element.bindValueOnChange);
};
var textInput = function (dictIsTextField) {
    return function (props) {
        return genericTextInput(dictIsTextField)("input")(Specular_Dom_Element.bindValueOnChange)(props);
    };
};
var textLiveInput = function (dictIsTextField) {
    return function (props) {
        return genericTextInput(dictIsTextField)("input")(Specular_Dom_Element.bindValueOnInput)(props);
    };
};
var fromMaybeDate = function (dict) {
    return dict.fromMaybeDate;
};
var fieldId = function (dictHasFieldId) {
    return function (field) {
        return Specular_Dom_Element.attr("data-field-id")(Restaumatic_Form.getFieldId(dictHasFieldId)(field));
    };
};
var fieldWrapper = function (dictHasFieldId) {
    return function (field) {
        return Specular_Dom_Element.el("div")([ fieldId(dictHasFieldId)(field) ]);
    };
};
var datePicker = function (dictIsRefLike) {
    return function (dictAsDate) {
        return function (props) {
            return function (field) {
                var parseMaybeDate = function (v) {
                    if (v === "") {
                        return new Data_Maybe.Just(Data_Maybe.Nothing.value);
                    };
                    return Data_Functor.map(Data_Maybe.functorMaybe)(Data_Maybe.Just.create)(DateUtils.parseISODate(v));
                };
                var displayedValue = Data_Functor.map(Specular_FRP_Base.functorDynamic)((function () {
                    var $44 = Data_Maybe.maybe("")(DateUtils.formatISODate);
                    var $45 = Control_Bind.join(Data_Maybe.bindMaybe);
                    var $46 = Data_Functor.map(Data_Maybe.functorMaybe)(toMaybeDate(dictAsDate));
                    return function ($47) {
                        return $44($45($46($47)));
                    };
                })())(Restaumatic_Form.readRefLike(dictIsRefLike)(field));
                return Specular_Dom_Element.el("input")(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Specular_Dom_Element.bindValueOnChange(new Specular_Ref.Ref(displayedValue, function (f) {
                    return function __do() {
                        var old = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(displayedValue)();
                        var str = f(old);
                        return Restaumatic_Form.writeRefLike(dictIsRefLike)(field)((function () {
                            var v = Control_Bind.bind(Data_Maybe.bindMaybe)(parseMaybeDate(str))(fromMaybeDate(dictAsDate));
                            if (v instanceof Data_Maybe.Nothing) {
                                var error = (function () {
                                    var $38 = str === "";
                                    if ($38) {
                                        return Restaumatic_Form.requiredError(Data_Unit.unit);
                                    };
                                    return Restaumatic_Form_Final.userVisibleError(Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.invalid));
                                })();
                                return new Restaumatic_Form.Invalid({
                                    error: error,
                                    editValue: new Data_Maybe.Just(str)
                                });
                            };
                            if (v instanceof Data_Maybe.Just) {
                                return new Restaumatic_Form.Valid({
                                    value: v.value0,
                                    editValue: new Data_Maybe.Just(str)
                                });
                            };
                            throw new Error("Failed pattern match at Restaumatic.Form.Widgets (line 165, column 17 - line 176, column 59): " + [ v.constructor.name ]);
                        })())();
                    };
                })), Specular_Dom_Element.on("blur")(function (v) {
                    return Restaumatic_Form.touchRefLike(dictIsRefLike)(field);
                }), Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringProp)("type")("date") ])(props))(Restaumatic_Prelude_Specular.wempty);
            };
        };
    };
};
var customField = function (dictEncode) {
    return function (dictDecode) {
        return function (spec) {
            return Data_Semigroup.append(Specular_Dom_Element.semigroupProp)(fieldId(Restaumatic_Form.hasFieldIdString)(spec.id))(Data_Semigroup.append(Specular_Dom_Element.semigroupProp)(Specular_Dom_Element.attr("data-custom-field-type")(spec.subtype))(Data_Semigroup.append(Specular_Dom_Element.semigroupProp)(setElementProperty("getCustomFieldProperties")(function __do() {
                var value = spec.getValue();
                return {
                    value: Data_Serialized.serialize(Foreign_Generic_Class.maybeEncode(dictEncode))(value)
                };
            }))(setElementProperty("setCustomFieldValue")(function (x) {
                return spec.setValue(Data_Serialized.deserialize(Unscramble.decodeMaybe(dictDecode))(x))();
            }))));
        };
    };
};
var checkbox = function (dictIsCheckboxField) {
    return function (props) {
        return function (field) {
            return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_FRP_Host.liftHost(Specular_Dom_Builder.monadCleanupBuilder)(Specular_Dom_Builder.monadEffectBuilder)(Restaumatic_Form.checkboxInput(dictIsCheckboxField)(field)))(function (i) {
                return Specular_Dom_Element.el("input")(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Specular_Dom_Element.bindChecked(new Specular_Ref.Ref(i.displayedValue, Specular_Callback.mkCallback(function (f) {
                    return function __do() {
                        var old = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(i.displayedValue)();
                        return i.onChange(f(old))();
                    };
                }))), Specular_Dom_Element.attr("type")("checkbox") ])(props))(Restaumatic_Prelude_Specular.wempty);
            });
        };
    };
};
export {
    _setElementProperty
} from "./foreign.js";
export {
    fromMaybeDate,
    toMaybeDate,
    select,
    radio,
    textInput,
    textLiveInput,
    textArea,
    genericTextInput,
    checkbox,
    datePicker,
    fieldWrapper,
    fieldId,
    customField,
    setElementProperty,
    asDateDate,
    asDateMaybeDate,
    asDateDay,
    asDateMaybeDay
};
//# sourceMappingURL=index.js.map
